import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_PROGRAMS_LIST, SUPERSET_PROGRAMS_LIST_ERROR, SUPERSET_PROGRAMS_LIST_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetProgramsList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_PROGRAMS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_PROGRAMS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_PROGRAMS_LIST_ERROR, payload: error });
  }
}

export function* watchSupersetProgramsList() {
  yield takeEvery(SUPERSET_PROGRAMS_LIST, supersetProgramsList);
}

function* supersetProgramsListSaga() {
  yield all([fork(watchSupersetProgramsList)]);
}

export default supersetProgramsListSaga;
